import { Panel } from "../../components/ui/Panel";
import { IntegrationHealth } from "./IntegrationHealth";

/**
 * Integration health (BUILD_PLAN.md section 17.2; ADR 0034), owner only: each
 * integration's status. The captures (ADR 0119) are a tool, on Owner tools
 * (ADR 0198).
 */
export function HealthPage() {
  return (
    <>
      <Panel>
        <h1 className="text-xl font-semibold tracking-tight">Integration health</h1>
        <p className="mt-1 text-muted">
          What the worker&apos;s jobs last recorded for each integration.
        </p>
      </Panel>
      <IntegrationHealth />
    </>
  );
}
